import z from 'zod';

const RoleSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable().optional(),
  editedAt: z.string(),
  createdAt: z.string(),
  isDefault: z.boolean(),
  isEditable: z.boolean(),
  roleType: z.string(),
});

const RoleSchemaV2 = RoleSchema.extend({
  users: z.array(z.object({ id: z.number() })),
  outputFeaturePermissions: z.record(z.string(), z.unknown()),
});

export const RoleListResponseSchema = z.array(RoleSchema);
export type RoleItem = z.infer<typeof RoleSchema>;
export type RoleItemV2 = z.infer<typeof RoleSchemaV2>;

export const PaginatedRoleListResponseSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(RoleSchemaV2),
});

export const AllRoleListResponseSchema = z.array(RoleSchemaV2);
